import React, { useState } from 'react';
import { Alert, Select, Spin } from 'antd';
import useCountries from '../../gql/hooks/useCountries'; 

const CountryChooser = ( { initialValue, onChange } ) => {    
    const [ selected, setSelected ] = useState();
    const { countries, countriesError, countriesLoading } = useCountries();
    
    /*****************************************
     * onChange is passed from the antd form
     * item. What you pass to this function 
     * will become the form item's value prop.
     *****************************************/

    const handleSelect = ( item ) => { 
        setSelected( setSelected );

        if ( onChange ) { 
            onChange( item ); 
        }  
    };

    return (
        <div>
            { countriesLoading && 
                <Spin />
            }
            
            { countriesError && 
                <Alert 
                    type="error"
                    message="Error"
                    description="An unknown error occurred. Please try again later."
                />
            }

            { countries && !countriesLoading && !countriesError && 
                <Select 
                    showSearch
                    value={ selected }
                    defaultValue={ initialValue }
                    onChange={ ( item ) => handleSelect( item ) }
                    optionFilterProp="children" 
                    filterOption={ ( input, option ) =>
                        ( option?.label ?? '' ).toLowerCase().includes( input.toLowerCase() )
                    }
                    options={ 
                        countries.map( i => ( 
                            {
                                value: i.id,
                                label: i.name,
                            }
                        ) )
                    }
                />
            }
        </div>
    );
};

export default CountryChooser;
